// import '@arco-design/web-react/es/Collapse/style/index.less';
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable import/first */
// @ts-nocheck
import { Collapse as ArcoCollapse } from '@arco-design/web-react';
/**
 * 保留 ArcoCollapse 的引入不被树摇，让组件arco样式的按需加载功能可用。
 */
(function (o) { })(ArcoCollapse);
import Collapse from './collapse';
export * from './interface';
export default Collapse;
